// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pickadate[data-v-2604fcb4]{\n  width:170px !important;\n}\n.pickadate input[data-v-2604fcb4]{\n  height:15px !important;\n  width:170px !important;\n}\n", ""]);
// Exports
module.exports = exports;
